import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {plainToClassFromExist} from "class-transformer";
import {ResultListApiModel} from "../models/result-list.api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {EquipmentApiModel} from "../models/equipment.api-model";

@Injectable()
export class EquipmentRestService {
  private readonly resource: string = '/equipment';

  constructor(
    public http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<EquipmentApiModel>> {
    queryParamsApiModel.pagination = false;
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<EquipmentApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<EquipmentApiModel>(EquipmentApiModel), result as object)));
  }
}
